import { render, staticRenderFns } from "./SubgroupForm.vue?vue&type=template&id=76910743&scoped=true"
import script from "./SubgroupForm.vue?vue&type=script&lang=js"
export * from "./SubgroupForm.vue?vue&type=script&lang=js"
import style0 from "./SubgroupForm.vue?vue&type=style&index=0&id=76910743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76910743",
  null
  
)

export default component.exports